import { useEffect, useMemo } from "react";
import { buildEntityColumn } from "./functions";
import { useHyperTable } from "./HyperTable";
import type { ColumnProps, Column as ColumnType } from "./types";

export const Column = <Entity extends any>(props: ColumnProps<Entity>) => {
  const { field, children, caption, deps = [], ...override } = props;
  const ctx = useHyperTable<Entity>();

  const id = override.id ?? field;

  const column = useMemo<ColumnType<Entity>>(
    () =>
      buildEntityColumn(ctx, {
        field,
        caption: caption ?? children,
        ...override,
      }),
    [JSON.stringify(override), field, caption, children, ctx.getEntity(), ...deps],
  );

  useEffect(() => {
    if (ctx.columnActions.has(column))
      ctx.columnActions.update(id, () => column);
  }, [column]);

  useEffect(() => {
    ctx.columnActions.add(column);
    return () => {
      ctx.columnActions.remove(id);
    };
  }, []);

  return null;
};
